export function pattern_cubes({compId,shapeHeight,animationSpeed,flipAnimation}) {
  return `
  <pattern class="patternRepeat" id="pat_${compId}" patternUnits="userSpaceOnUse" style="transform: translate(${-shapeHeight*4}px,0)" height="${shapeHeight}" viewbox="0 0 1920 240" x="50%" y="0" preserveAspectRatio="none" width="${shapeHeight*8}">
  <g>
    <polygon fill="#444444" points="1040,101.1 1000,121.1 1000,171.1 1040,191.1 1080,171.1 1080,121.1 	"/>
    <polygon points="1080,121.1 1040,141.1 1040,191.1 1080,171.1 	"/>
    <polygon fill="#aaaaaa" points="1000,171.1 1040,191.1 1040,141.1 1000,121.1 	"/>
  </g>
  <g>
    <polygon fill="#444444" points="1080,30.7 1040,50.7 1040,100.7 1080,120.7 1120,100.7 1120,50.7 	"/>
    <polygon points="1120,50.7 1080,70.7 1080,120.7 1120,100.7 	"/>
    <polygon fill="#aaaaaa" points="1040,100.7 1080,120.7 1080,70.7 1040,50.7 	"/>
  </g>
  <g class="st3">
    <polygon fill="#444444" points="440,80 400,100 400,150 440,170 480,150 480,100 	"/>
    <polygon points="480,100 440,120 440,170 480,150 	"/>
    <polygon fill="#aaaaaa" points="400,150 440,170 440,120 400,100 	"/>
  </g>
  <g class="st3">
    <polygon fill="#444444" points="440,30.6 400,50.6 400,100.6 440,120.6 480,100.6 480,50.6 	"/>
    <polygon points="480,50.6 440,70.6 440,120.6 480,100.6 	"/>
    <polygon fill="#aaaaaa" points="400,100.6 440,120.6 440,70.6 400,50.6 	"/>
  </g>


  <g>
    <polygon fill="#444444" points="1760,100 1720,120 1720,170 1760,190 1800,170 1800,120 	"/>
    <polygon points="1800,120 1760,140 1760,190 1800,170 	"/>
    <polygon fill="#aaaaaa" points="1720,170 1760,190 1760,140 1720,120 	"/>
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 1;0 -50;0 1;0 1"
    keyTimes="0;0.5;1;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.2 * animationSpeed}s"
    dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
  </g>
  <g>
    <polygon fill="#444444" points="1600,100 1560,120 1560,170 1600,190 1640,170 1640,120 	"/>
    <polygon points="1640,120 1600,140 1600,190 1640,170 	"/>
    <polygon fill="#aaaaaa" points="1560,170 1600,190 1600,140 1560,120 	"/>
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 1;0 -50;0 1;0 1"
    keyTimes="0;0.5;1;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.4 * animationSpeed}s"
    dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
  </g>
  <g>
    <polygon fill="#444444" points="1440,100 1400,120 1400,170 1440,190 1480,170 1480,120 	"/>
    <polygon points="1480,120 1440,140 1440,190 1480,170 	"/>
    <polygon fill="#aaaaaa" points="1400,170 1440,190 1440,140 1400,120 	"/>
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 1;0 -50;0 1;0 1"
    keyTimes="0;0.5;1;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-0.8 * animationSpeed}s"
    dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
  </g>
  <g>
    <polygon fill="#444444" points="1040,50.6 1000,70.6 1000,120.6 1040,140.6 1080,120.6 1080,70.6 	"/>
    <polygon points="1080,70.6 1040,90.6 1040,140.6 1080,120.6 	"/>
    <polygon fill="#aaaaaa" points="1000,120.6 1040,140.6 1040,90.6 1000,70.6 	"/>
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 0;0 -50;0 0;0 0"
    keyTimes="0;0.5;1;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-1.4 * animationSpeed}s"
    dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
  </g>
  <g>
    <polygon fill="#444444" points="640,100 600,120 600,170 640,190 680,170 680,120 	"/>
    <polygon points="680,120 640,140 640,190 680,170 	"/>
    <polygon fill="#aaaaaa" points="600,170 640,190 640,140 600,120 	"/>
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 1;0 -50;0 1;0 1"
    keyTimes="0;0.5;1;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-2 * animationSpeed}s"
    dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
  </g>
  <g>
    <polygon fill="#444444" points="400,100 360,120 360,170 400,190 440,170 440,120 	"/>
    <polygon points="440,120 400,140 400,190 440,170 	"/>
    <polygon fill="#aaaaaa" points="360,170 400,190 400,140 360,120 	"/>
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 1;0 -50;0 1;0 1"
    keyTimes="0;0.5;1;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-2.4 * animationSpeed}s"
    dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
  </g>
  <g>
    <polygon fill="#444444" points="80,100 40,120 40,170 80,190 120,170 120,120 	"/>
    <polygon points="120,120 80,140 80,190 120,170 	"/>
    <polygon fill="#aaaaaa" points="40,170 80,190 80,140 40,120 	"/>
    <animateTransform attributeType="xml" attributeName="transform" type="translate"
    values="0 1;0 -50;0 1;0 1"
    keyTimes="0;0.5;1;1"
    keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
    begin="${-3 * animationSpeed}s"
    dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
  </g>



  <path fill="#444444" d="M1880,120.6l-40,20l-40-20l-40,20l-40-20l-40,20v-50l-40-20l-40,20v50l-40-20v-10l-40-20l-40,20v10l-40,20
    l-40-20l-40,20l-40-20l-40-20v-50l-40-20l-40,20v5l-40,20v45l-40-20l-40,20l-40,20v-50l-40-20v-50l-40-20l-40,20v50l-40-20l-40-20
    l-40,20l-40-20l-40,20v40l-40-20l-40,20v50l-40-20l-40-20l-40,20l-40-20l-40,20l-40,20l-40-20v-10l-40-20l-40,20v10l-40-20l-40,20
    l-40-20l-40,20v40l-40-20l-40-20l-40,20v50l40,20l40,20l40-20l40,20l40-20l40-20l40,20l40,20l40-20l40-20l40,20l40,20l40-20l40,20
    l40-20l40-20l40,20l40,20l40-20l40-20l40,20l40,20l40-20l40,20l40-20l40,20l40-20l40-20l40-20l40,20l40,20l40,20l40-20l40,20l40-20
    l40-20l40,20l40,20l40-20l40-20l40,20l40,20l40-20l40,20l40-20l40-20l40,20l40-20v-50L1880,120.6z"/>
  <path fill="#aaaaaa" d="M120,120.6l40,20l-40,20l40,20v50l-40-20v-40v-10V120.6z M1000,210.6l40,20v-50l-40-20V210.6z M1160,120.6
    l40-20l40,20v-50l-40-20v45l-40-20V120.6v5v45l40,20l40,20l40,20v-50l-40-20L1160,120.6z M1320,210.6l40,20v-50l-40-20V210.6z
     M400,140.6v10v40l40,20l40,20v-50L400,140.6L400,140.6z M1840,140.6v50l40,20v-50L1840,140.6z M800,140.6v50l40,20l40,20v-50
    l-40-20L800,140.6z M840,120.6l40,20v-50l-40-20V120.6z M960,90.6v-50l-40-20v50v50l40,20l40,20v-50L960,90.6z M680,110.6l-40-20v50
    v50l40,20l40,20v-50l-40-20V110.6z M760,70.6l-40-20v50l40,20l40,20v-50L760,70.6z M920,210.6l40,20v-50l-40-20V210.6z M1480,160.6
    l-40-20v50l40,20l40,20v-50v-50l-40-20V160.6z M1640,110.6l-40-20v50v50l40,20l40,20v-50l-40-20V110.6z M1720,210.6l40,20v-50
    l-40-20V210.6z M520,210.6l40,20v-50l-40-20V210.6z M280,160.6l-40-20v50l40,20l40,20v-50v-50l-40-20V160.6z M0,140.6v50l40,20
    l40,20v-50l-40-20L0,140.6z"/>
  <path d="M1920,140.6v48.7v1.3v48.7H0v-20.1v-29.9l40,20l40,20v-48.7l40-20v48.7l40,20v-48.7l40-20l40-20v48.7l40,20
    l40,20v-48.7v-50l40-20v50l40-20v48.7l40,20l40,20v-48.7l40-20v48.7l40,20v-48.7l40-20l40-20v48.7l40,20l40,20v-48.7l40-20l40-20
    v48.7l40,20l40,20v-48.7l40-20v48.7l40,20v-48.7l40-20v48.7l40,20v-48.7l40-20l40-20l40-20v50l40,18.7l40,20l40,20v-48.7l40-20v48.7
    l40,20v-48.7l40-20l40-20v48.7l40,20l40,20v-48.7v-50l40-20v50l40-20v48.7l40,20l40,20v-48.7l40-20v48.7l40,20v-48.7l40-20l40-20v50
    l40,18.7v-48.7L1920,140.6z M920,70.6l-40,20v50l40-20V70.6z M1040,90.6l-40,20v50l40-20V90.6z M720,90.6l-40,20v50l40-20V90.6z
     M1000,20.6l-40,20v50l40-20V20.6z M840,70.6l-40,20v50l40-20V70.6z M1280,50.6l-40,20v50l40-20V50.6z M1680,90.6l-40,20v50l40-20
    V90.6z"/>


    <g>
      <polygon fill="#444444" points="1840,140 1800,160 1800,210 1880,210 1880,160 	"/>
      <polygon points="1880,160 1840,180 1840,230 1880,210 	"/>
      <polygon fill="#aaaaaa" points="1800,210 1840,230 1840,180 1800,160 	"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 -50;0 0;0 0"
      keyTimes="0;0.5;1;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-0 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </g>
    <g class="st7">
      <polygon fill="#444444" points="1520,40 1480,60 1480,110 1560,110 1560,60 	"/>
      <polygon points="1560,60 1520,80 1520,130 1560,110 	"/>
      <polygon fill="#aaaaaa" points="1480,110 1520,130 1520,80 1480,60 	"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 2;0 -30;0 2;0 2"
      keyTimes="0;0.5;1;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-0.6 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </g>
    <g class="st7">
      <polygon fill="#444444" points="1320,70 1280,90 1280,140 1360,140 1360,90 	"/>
      <polygon points="1360,90 1320,110 1320,160 1360,140 	"/>
      <polygon fill="#aaaaaa" points="1280,140 1320,160 1320,110 1280,90 	"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 -50;0 0;0 0"
      keyTimes="0;0.5;1;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-1 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </g>
    <g class="st7">
      <polygon fill="#444444" points="1160,120 1120,140 1120,190 1200,190 1200,140 	"/>
      <polygon points="1200,140 1160,160 1160,210 1200,190 	"/>
      <polygon fill="#aaaaaa" points="1120,190 1160,210 1160,160 1120,140 	"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 -50;0 0;0 0"
      keyTimes="0;0.5;1;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-1.2 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </g>
    <g class="st7">
      <polygon fill="#444444" points="920,70 880,90 880,140 960,140 960,90 	"/>
      <polygon points="960,90 920,110 920,160 960,140 	"/>
      <polygon fill="#aaaaaa" points="880,140 920,160 920,110 880,90 	"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 -50;0 0;0 0"
      keyTimes="0;0.5;1;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-1.6 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </g>
    <g class="st7">
      <polygon fill="#444444" points="760,70 720,90 720,140 800,140 800,90 	"/>
      <polygon points="800,90 760,110 760,160 800,140 	"/>
      <polygon fill="#aaaaaa" points="720,140 760,160 760,110 720,90 	"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 1;0 -50;0 1;0 1"
      keyTimes="0;0.5;1;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-1.8 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </g>
    <g class="st7">
      <polygon fill="#444444" points="520,70 480,90 480,140 560,140 560,90 	"/>
      <polygon points="560,90 520,110 520,160 560,140 	"/>
      <polygon fill="#aaaaaa" points="480,140 520,160 520,110 480,90 	"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 0;0 -50;0 0;0 0"
      keyTimes="0;0.5;1;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-2.2 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </g>
    <g class="st7">
      <polygon fill="#444444" points="320,40 280,60 280,110 360,110 360,60 	"/>
      <polygon points="360,60 320,80 320,130 360,110 	"/>
      <polygon fill="#aaaaaa" points="280,110 320,130 320,80 280,60 	"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 2;0 -30;0 2;0 2"
      keyTimes="0;0.5;1;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-2.6 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </g>
    <g class="st7">
      <polygon fill="#444444" points="200,70.6 160,90.6 160,140.6 240,140.6 240,90.6 	"/>
      <polygon points="240,90.6 200,110.6 200,160.6 240,140.6 	"/>
      <polygon fill="#aaaaaa" points="160,140.6 200,160.6 200,110.6 160,90.6 	"/>
      <animateTransform attributeType="xml" attributeName="transform" type="translate"
      values="0 1;0 -50;0 1;0 1"
      keyTimes="0;0.5;1;1"
      keySplines="0.37, 0, 0.63, 1;0.37, 0, 0.63, 1;0.37, 0, 0.63, 1" calcMode="spline"
      begin="${-2.8 * animationSpeed}s"
      dur="${3 * animationSpeed}s" repeatCount="indefinite"/>
    </g>

  </pattern>
<mask id="mask_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" width="100%" height="${shapeHeight}" fill="url(#pat_${compId})"></rect>
</mask>
<mask class="flipped" id="mask_single_${compId}">
  <rect class="animdiv-mask animdiv-mask-top" x="50%" width="1920" height="${shapeHeight}" fill="url(#single_${compId})"></rect>
</mask>
`;
}